import DashboardMain from "@/components/dashboard/dashboard/DashboardMain";

export default function Home() {
  return <DashboardMain />;
}
